export default "__VITE_PUBLIC_ASSET__52f538d9__"